const isObject = (object) => {
  return typeof object === 'object' && object !== null && !Array.isArray(object);
};

export default isObject;
